"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

var _theme = require("@zip/theme");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgHooray = function SvgHooray(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  var theme = (0, _react.useTheme)();

  switch (theme.name) {
    case _theme.fearlessBusiness.name:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 77 77",
        fill: "none"
      }, props), {}, {
        children: [title ? (0, _jsxRuntime.jsx)("title", {
          children: title
        }) : null, (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.572 57.507c1.233 3.123 1.66 6.114 1.238 8.779-.311 1.957-1.002 3.243-1.334 3.773L4.27 72.687l6.302-15.18zm21.373-30.53c-.105.11-.208.219-.314.326a1.515 1.515 0 000 2.127 1.477 1.477 0 002.106 0c.187-.189.37-.38.553-.573a101.867 101.867 0 016.988 6.451 104.74 104.74 0 015.584 6.092c-.27.15-.538.304-.807.46a1.512 1.512 0 00-.545 2.055c.276.482.777.752 1.291.752.253 0 .509-.065.743-.202.414-.24.827-.472 1.24-.698.648.83 1.248 1.636 1.79 2.41 2.218 3.16 2.816 4.775 2.973 5.475-.692-.16-2.29-.763-5.42-3.003-3.238-2.316-7.06-5.651-10.761-9.39-3.702-3.739-7.003-7.599-9.297-10.868-2.218-3.162-2.815-4.776-2.973-5.475.693.159 2.291.762 5.421 3.002.465.332.942.688 1.428 1.06zm12.759 22.86c.899.693 1.77 1.33 2.602 1.896.95.647 1.816 1.186 2.607 1.622l-7.024 2.975c.797-1.666 1.5-3.812 1.815-6.493zm-28.108-6.838c4.63 8.865 4.977 14.74 4.376 18.198-.6 3.457-2.192 5.123-2.645 5.536l-3.924 1.662c.872-3.136 1.102-8.114-2.27-14.65L16.597 43zm6.478 21.724c.306-.78.576-1.67.771-2.677 1.192-6.144-.754-13.74-5.78-22.587l1.612-3.88c1.275 1.55 2.728 3.743 3.316 5.127.242.569.792.91 1.369.91.196 0 .396-.04.587-.123a1.51 1.51 0 00.78-1.975c-.873-2.052-3.087-5.245-4.78-7.002l2.461-5.929c.432.799.966 1.674 1.606 2.633.441.66.924 1.345 1.444 2.049 5.093 7.806 4.978 15.796 3.982 21.127-1.058 5.67-3.326 9.822-4.158 10.967l-3.21 1.36zm7.614-3.225a38.183 38.183 0 002.68-8.544c.692-3.702.996-8.57-.283-13.826.705.752 1.43 1.506 2.175 2.258a106.069 106.069 0 006.629 6.166c-.214 7.1-3.438 10.336-4.132 10.952l-7.07 2.994zm22.94-16.15a56.742 56.742 0 00-2.13-2.96c2.852-1.334 5.691-2.307 8.48-2.904a1.504 1.504 0 001.149-1.782 1.489 1.489 0 00-1.766-1.16c-3.228.69-6.507 1.844-9.786 3.438a106.119 106.119 0 00-6.192-6.799 104.698 104.698 0 00-7.14-6.598 34.066 34.066 0 004.86-8.532C43.024 13.178 44 7.611 44 1.504 44 .674 43.333 0 42.511 0c-.822 0-1.489.673-1.489 1.504 0 9.41-2.389 17.198-7.106 23.208a54.849 54.849 0 00-2.578-1.878c-4.413-3.006-7.041-3.71-8.51-2.28l-.032.03-.004.004-.003.003c-.376.38-.608.841-.696 1.39L.116 74.915a1.515 1.515 0 00.32 1.645 1.482 1.482 0 001.629.324l.004-.002 52.403-22.196c.006-.002-.005.003 0 0a2.437 2.437 0 001.35-.679l.03-.027.004-.004.03-.032c1.415-1.484.718-4.139-2.259-8.595z",
          fill: "#124099"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M62.356 68.578h-5.18a1.197 1.197 0 01-1.19-1.203c0-.665.533-1.203 1.19-1.203h5.18c.658 0 1.19.538 1.19 1.203s-.532 1.203-1.19 1.203zM61.163 72.188h-5.178a1.197 1.197 0 01-1.19-1.204c0-.665.533-1.203 1.19-1.203h5.178c.66 0 1.192.538 1.192 1.203 0 .666-.533 1.204-1.192 1.204z",
          fill: "#D0EEFD"
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "hooray_svg__a",
          maskUnits: "userSpaceOnUse",
          x: 55,
          y: 15,
          width: 22,
          height: 9,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M55.167 15.04h21.068v8.665H55.167V15.04z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsxs)("g", {
          mask: "url(#hooray_svg__a)",
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#AEDEFF",
          children: [(0, _jsxRuntime.jsx)("path", {
            d: "M55.603 23.264a1.477 1.477 0 002.106 0c3.327-3.36 8.717-4.9 12.652-5.22a1.5 1.5 0 001.364-1.62 1.494 1.494 0 00-1.604-1.379c-4.463.364-10.62 2.155-14.518 6.092a1.515 1.515 0 000 2.127z"
          }), (0, _jsxRuntime.jsx)("path", {
            opacity: 0.5,
            d: "M75.132 15.334a7.443 7.443 0 00-.129-.034 1.488 1.488 0 00-1.804 1.096 1.505 1.505 0 001.085 1.823l.076.02a1.479 1.479 0 001.824-1.063 1.506 1.506 0 00-1.052-1.842z"
          })]
        }), (0, _jsxRuntime.jsx)("path", {
          opacity: 0.5,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M49.909 14.296a1.5 1.5 0 001.489-1.504 1.5 1.5 0 00-1.49-1.504 1.5 1.5 0 00-1.488 1.504 1.5 1.5 0 001.489 1.504z",
          fill: "#AEDEFF"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.933 43.393a1.483 1.483 0 00-1.969-.755 1.51 1.51 0 00-.776 1.918 1.478 1.478 0 001.883.882 1.508 1.508 0 00.862-2.045z",
          fill: "#AEDEFF"
        }), (0, _jsxRuntime.jsx)("path", {
          opacity: 0.5,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M66.883 44.224a1.5 1.5 0 00-1.489-1.504 1.5 1.5 0 00-1.489 1.504 1.5 1.5 0 001.49 1.504 1.5 1.5 0 001.488-1.504z",
          fill: "#86D1FF"
        }), (0, _jsxRuntime.jsx)("path", {
          opacity: 0.5,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M69.86 53.998a1.5 1.5 0 00-1.488 1.505 1.5 1.5 0 001.489 1.504 1.5 1.5 0 001.489-1.504 1.5 1.5 0 00-1.49-1.505zM20.725 4.512a1.5 1.5 0 001.49-1.504 1.5 1.5 0 00-1.49-1.504 1.5 1.5 0 00-1.489 1.504 1.5 1.5 0 001.49 1.504z",
          fill: "#AEDEFF"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M52.788 26.057h-1.975v-1.994c0-.666-.532-1.204-1.19-1.204-.66 0-1.192.538-1.192 1.203v1.995h-1.975c-.659 0-1.191.538-1.191 1.203 0 .666.532 1.203 1.19 1.203h1.976v1.994c0 .665.532 1.203 1.191 1.203s1.191-.538 1.191-1.203v-1.994h1.975c.659 0 1.191-.537 1.191-1.203 0-.665-.532-1.203-1.19-1.203z",
          fill: "#D0EEFD"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.67 14.026h-1.974v-1.995c0-.665-.533-1.203-1.192-1.203-.658 0-1.19.538-1.19 1.203v1.995H8.337c-.658 0-1.19.538-1.19 1.203 0 .666.532 1.203 1.19 1.203h1.975v1.994c0 .665.533 1.203 1.191 1.203.66 0 1.192-.538 1.192-1.203v-1.994h1.975c.658 0 1.19-.537 1.19-1.203 0-.665-.532-1.203-1.19-1.203z",
          fill: "#AEDEFF"
        })]
      }));

    default:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 77 77",
        fill: "none"
      }, props), {}, {
        children: [title ? (0, _jsxRuntime.jsx)("title", {
          children: title
        }) : null, (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.572 57.507c1.233 3.123 1.66 6.114 1.238 8.779-.311 1.957-1.002 3.243-1.334 3.773L4.27 72.687l6.302-15.18zm21.373-30.53c-.105.11-.208.219-.314.326a1.515 1.515 0 000 2.127 1.477 1.477 0 002.106 0c.187-.189.37-.38.553-.573a101.867 101.867 0 016.988 6.451 104.74 104.74 0 015.584 6.092c-.27.15-.538.304-.807.46a1.512 1.512 0 00-.545 2.055c.276.482.777.752 1.291.752.253 0 .509-.065.743-.202.414-.24.827-.472 1.24-.698.648.83 1.248 1.636 1.79 2.41 2.218 3.16 2.816 4.775 2.973 5.475-.692-.16-2.29-.763-5.42-3.003-3.238-2.316-7.06-5.651-10.761-9.39-3.702-3.739-7.003-7.599-9.297-10.868-2.218-3.162-2.815-4.776-2.973-5.475.693.159 2.291.762 5.421 3.002.465.332.942.688 1.428 1.06zm12.759 22.86c.899.693 1.77 1.33 2.602 1.896.95.647 1.816 1.186 2.607 1.622l-7.024 2.975c.797-1.666 1.5-3.812 1.815-6.493zm-28.108-6.838c4.63 8.865 4.977 14.74 4.376 18.198-.6 3.457-2.192 5.123-2.645 5.536l-3.924 1.662c.872-3.136 1.102-8.114-2.27-14.65L16.597 43zm6.478 21.724c.306-.78.576-1.67.771-2.677 1.192-6.144-.754-13.74-5.78-22.587l1.612-3.88c1.275 1.55 2.728 3.743 3.316 5.127.242.569.792.91 1.369.91.196 0 .396-.04.587-.123a1.51 1.51 0 00.78-1.975c-.873-2.052-3.087-5.245-4.78-7.002l2.461-5.929c.432.799.966 1.674 1.606 2.633.441.66.924 1.345 1.444 2.049 5.093 7.806 4.978 15.796 3.982 21.127-1.058 5.67-3.326 9.822-4.158 10.967l-3.21 1.36zm7.614-3.225a38.183 38.183 0 002.68-8.544c.692-3.702.996-8.57-.283-13.826.705.752 1.43 1.506 2.175 2.258a106.069 106.069 0 006.629 6.166c-.214 7.1-3.438 10.336-4.132 10.952l-7.07 2.994zm22.94-16.15a56.742 56.742 0 00-2.13-2.96c2.852-1.334 5.691-2.307 8.48-2.904a1.504 1.504 0 001.149-1.782 1.489 1.489 0 00-1.766-1.16c-3.228.69-6.507 1.844-9.786 3.438a106.119 106.119 0 00-6.192-6.799 104.698 104.698 0 00-7.14-6.598 34.066 34.066 0 004.86-8.532C43.024 13.178 44 7.611 44 1.504 44 .674 43.333 0 42.511 0c-.822 0-1.489.673-1.489 1.504 0 9.41-2.389 17.198-7.106 23.208a54.849 54.849 0 00-2.578-1.878c-4.413-3.006-7.041-3.71-8.51-2.28l-.032.03-.004.004-.003.003c-.376.38-.608.841-.696 1.39L.116 74.915a1.515 1.515 0 00.32 1.645 1.482 1.482 0 001.629.324l.004-.002 52.403-22.196c.006-.002-.005.003 0 0a2.437 2.437 0 001.35-.679l.03-.027.004-.004.03-.032c1.415-1.484.718-4.139-2.259-8.595z",
          fill: "#6542BE"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M62.356 68.578h-5.18a1.197 1.197 0 01-1.19-1.203c0-.665.533-1.203 1.19-1.203h5.18c.658 0 1.19.538 1.19 1.203s-.532 1.203-1.19 1.203zM61.163 72.188h-5.178a1.197 1.197 0 01-1.19-1.204c0-.665.533-1.203 1.19-1.203h5.178c.66 0 1.192.538 1.192 1.203 0 .666-.533 1.204-1.192 1.204z",
          fill: "#EDE6FF"
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "hooray_svg__a",
          maskUnits: "userSpaceOnUse",
          x: 55,
          y: 15,
          width: 22,
          height: 9,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M55.167 15.04h21.068v8.665H55.167V15.04z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsxs)("g", {
          mask: "url(#hooray_svg__a)",
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "#DBCCFF",
          children: [(0, _jsxRuntime.jsx)("path", {
            d: "M55.603 23.264a1.477 1.477 0 002.106 0c3.327-3.36 8.717-4.9 12.652-5.22a1.5 1.5 0 001.364-1.62 1.494 1.494 0 00-1.604-1.379c-4.463.364-10.62 2.155-14.518 6.092a1.515 1.515 0 000 2.127z"
          }), (0, _jsxRuntime.jsx)("path", {
            opacity: 0.5,
            d: "M75.132 15.334a7.443 7.443 0 00-.129-.034 1.488 1.488 0 00-1.804 1.096 1.505 1.505 0 001.085 1.823l.076.02a1.479 1.479 0 001.824-1.063 1.506 1.506 0 00-1.052-1.842z"
          })]
        }), (0, _jsxRuntime.jsx)("path", {
          opacity: 0.5,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M49.909 14.296a1.5 1.5 0 001.489-1.504 1.5 1.5 0 00-1.49-1.504 1.5 1.5 0 00-1.488 1.504 1.5 1.5 0 001.489 1.504z",
          fill: "#DBCCFF"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.933 43.393a1.483 1.483 0 00-1.969-.755 1.51 1.51 0 00-.776 1.918 1.478 1.478 0 001.883.882 1.508 1.508 0 00.862-2.045z",
          fill: "#DBCCFF"
        }), (0, _jsxRuntime.jsx)("path", {
          opacity: 0.5,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M66.883 44.224a1.5 1.5 0 00-1.489-1.504 1.5 1.5 0 00-1.489 1.504 1.5 1.5 0 001.49 1.504 1.5 1.5 0 001.488-1.504z",
          fill: "#C9B3FF"
        }), (0, _jsxRuntime.jsx)("path", {
          opacity: 0.5,
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M69.86 53.998a1.5 1.5 0 00-1.488 1.505 1.5 1.5 0 001.489 1.504 1.5 1.5 0 001.489-1.504 1.5 1.5 0 00-1.49-1.505zM20.725 4.512a1.5 1.5 0 001.49-1.504 1.5 1.5 0 00-1.49-1.504 1.5 1.5 0 00-1.489 1.504 1.5 1.5 0 001.49 1.504z",
          fill: "#DBCCFF"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M52.788 26.057h-1.975v-1.994c0-.666-.532-1.204-1.19-1.204-.66 0-1.192.538-1.192 1.203v1.995h-1.975c-.659 0-1.191.538-1.191 1.203 0 .666.532 1.203 1.19 1.203h1.976v1.994c0 .665.532 1.203 1.191 1.203s1.191-.538 1.191-1.203v-1.994h1.975c.659 0 1.191-.537 1.191-1.203 0-.665-.532-1.203-1.19-1.203z",
          fill: "#EDE6FF"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.67 14.026h-1.974v-1.995c0-.665-.533-1.203-1.192-1.203-.658 0-1.19.538-1.19 1.203v1.995H8.337c-.658 0-1.19.538-1.19 1.203 0 .666.532 1.203 1.19 1.203h1.975v1.994c0 .665.533 1.203 1.191 1.203.66 0 1.192-.538 1.192-1.203v-1.994h1.975c.658 0 1.19-.537 1.19-1.203 0-.665-.532-1.203-1.19-1.203z",
          fill: "#DBCCFF"
        })]
      }));
  }
};

var _default = SvgHooray;
exports["default"] = _default;